<template>
  <div class="header-wrapper row m-0">

    <img
        v-if="showLogo"
        style="height:  32px;"
        class="img-fluid logo-title"
        src="../../assets/images/logo/logo.png"
        alt=""
    />

    <Logo/>
    <div class="left-header col horizontal-wrapper pl-0" v-if="!hideSomeDropdowns">
      <ul class="horizontal-menu">
        <BonusUI/>
      </ul>
    </div>
    <div class="nav-right col-8 pull-right right-header p-0">
      <ul class="nav-menus">
        <li class="language-nav" v-if="isAuthenticated && commentsArray.length">
          <Notifications :commentsArray="commentsArray"></Notifications>
          <!--                  <a class="text-dark" href="javascript:void(0)">-->
          <!--                    <feather type="message-square"></feather></a>-->
        </li>
        <li class="language-nav">
          <Language/>
        </li>
        <li class="maximize">
          <Maximize/>
        </li>
        <Profile v-if="!hideSomeDropdowns" :menuPages="menuPages"/>
      </ul>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import BonusUI from './bonusUI';
import Language from './language';
import Maximize from './maximize';
import Profile from './profile';
import Logo from './logo';
import Notifications from '../header/notifications.vue'

export default {
  name: 'Search',
  components: {
    BonusUI,
    Language,
    Maximize,
    Profile,
    Logo,
    Notifications
  },
  data() {
    return {
      bookmark: false,
      hideSomeDropdowns: true,
      menuPages: [],
      commentsArray: []
    };
  },
  created() {
    this.loadPages()

    let timer = this.$store.getters['shared/getCommentsTimer']

    if (!timer) {

      let setter = setInterval(this.checkComments, 30000);
      this.$store.dispatch('shared/setCommentsTimer', setter)
    }
  },
  mounted() {

    if (this.$route.name == 'SinglePage') {
      this.hideSomeDropdowns = true
    } else {
      this.hideSomeDropdowns = false
    }

    if (this.$route.name == 'pdfExportPage') {
      this.hideInfo = true
    } else {
      this.hideInfo = false
    }

  },

  computed: {
    ...mapState({
      menuItems: (state) => state.menu.searchData,
      megamenuItems: (state) => state.menu.megamenu,
      searchOpen: (state) => state.menu.searchOpen,
    }),
    isAuthenticated() {
      return this.$store.getters['shared/isAuthenticated']
    },
    showLogo() {
      return this.$route.name == 'ProjectsList' || this.$route.name == 'UserProfile'
    }
  },
  methods: {

    checkComments() {

      this.$store.dispatch('projects/getAllComments').then((comments) => {

        this.commentsArray = comments.data.result
      })


    },
    getTitle(translations) {
      return translations[0].name
    },

    async loadPages() {

      let response = await this.$store.dispatch('shared/getPages')

      let pages = response.data.result.filter((item) => {
        return item.in_plan
      })

      pages.forEach((item) => {
        this.menuPages.push({
          title: this.getTitle(item.translation),
          slug: item.slug
        })
      })
    },
    search_open() {
      this.$store.state.menu.searchOpen = true;
    }
  }
};
</script>
<style>

.logo-title {
  display: inline;
}

@media only screen and (max-width: 991px) {
  .logo-title {
    display: none;
  }
}
</style>